"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserRoleType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var PermissionGroupV3_1 = require("./PermissionGroupV3");
var UserRoleType_Factory = /** @class */ (function () {
    function UserRoleType_Factory() {
    }
    UserRoleType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            PermissionGroup: PermissionGroupV3_1.PermissionGroupV3_Factory.CreateIncoming(model.PermissionGroup),
            UserRole: model.UserRole,
            UserRoleTypeCode: model.UserRoleTypeCode,
        };
        return result;
    };
    UserRoleType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            PermissionGroup: PermissionGroupV3_1.PermissionGroupV3_Factory.CreateOutgoing(model.PermissionGroup),
            UserRole: model.UserRole,
            UserRoleTypeCode: model.UserRoleTypeCode,
        };
        return result;
    };
    return UserRoleType_Factory;
}());
exports.UserRoleType_Factory = UserRoleType_Factory;
